import CategoryIcon from "@mui/icons-material/Category";
import { Box, Chip, Paper, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { GameSessionModeCategoryContent } from "../../types/api";
import { getLocalizedField } from "../../utils/helpers";

interface ImposterContentInfoProps {
  content: GameSessionModeCategoryContent;
  getImageUrl: (imagePath: string | null) => string | null;
}

const ImposterContentInfo: React.FC<ImposterContentInfoProps> = ({
  content,
  getImageUrl,
}) => {
  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const neonPalette = (theme.palette as any).neon;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
        justifyContent: "center",
        backgroundColor: theme.palette.background.paper,
        border: `3px solid ${neonPalette.cyan}`,
        borderRadius: 3,
        boxShadow: `0 4px 16px ${neonPalette.cyan}40, 0 2px 8px ${neonPalette.cyan}20`,
      }}
    >
      {content.content.category && (
        <>
          <Chip
            icon={(() => {
              const categoryIconPath =
                i18n.language === "ar" && content.content.category.icon_ar
                  ? content.content.category.icon_ar
                  : content.content.category.icon ||
                    content.content.category.icon_ar;
              const categoryIconUrl = getImageUrl(categoryIconPath || null);
              return categoryIconUrl ? (
                <Box
                  component="img"
                  src={categoryIconUrl}
                  alt={getLocalizedField(content.content.category)}
                  sx={{
                    width: 30,
                    height: 30,
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              ) : (
                <CategoryIcon sx={{ fontSize: 20 }} />
              );
            })()}
            label={getLocalizedField(content.content.category)}
            sx={{
              backgroundColor: neonPalette.cyanLight,
              color: theme.palette.text.primary,
              fontWeight: 700,
              border: `1.5px solid ${neonPalette.cyan}`,
              boxShadow: `0 2px 6px ${neonPalette.cyan}30`,
            }}
          />
          {content.content.difficulty && (
            <Chip
              label={`${content.content.difficulty.value} ${t("gameBoard.points")}`}
              sx={{
                backgroundColor: neonPalette.yellowLight,
                color: theme.palette.text.primary,
                fontWeight: 700,
                border: `1.5px solid ${neonPalette.yellow}`,
                boxShadow: `0 2px 6px ${neonPalette.yellow}30`,
              }}
            />
          )}
        </>
      )}
    </Paper>
  );
};

export default ImposterContentInfo;
